import { Component, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { SiteContentItem, SiteContentItemType } from '../app.component';
import { TranslationService } from '../app.translation-service';

/**
 * MenuOption
 */
interface MenuOption {
	id: number;
	name: string;
	typeClass: string;
}

/**
 * Classes per item type
 */
const CLASSES_PER_TYPE = {
	[SiteContentItemType.Dark]: 'dark',
	[SiteContentItemType.Standard]: '',
	[SiteContentItemType.Milk]: 'milk',
	[SiteContentItemType.White]: 'white',
};

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.less']
})
export class MenuComponent implements OnChanges {

	/**
	 * Options
	 */
	public options: MenuOption[];

	/**
	 * Site content
	 */
	 @Input()
	 public siteContent?: SiteContentItem[] | null;

	/**
	 * Selected option input
	 */
	@Input()
	public selectedOption?: number | null;

	/**
	 * Selected option output
	 */
	@Output()
	public selectedOptionChange: EventEmitter<number | null> = new EventEmitter<number | null>();

	/**
	 * Highlighted option output
	 */
	 @Output()
	public highlightedOptionChange: EventEmitter<number | null> = new EventEmitter<number | null>();

	/**
	 * Constructor
	 */
	constructor(public i18n: TranslationService) {
		this.selectedOption = null;
		this.options = [];
	}

	/**
	 * Select option
	 */
	public selectOption(optionId?: number | null): void {
		if (this.selectedOption === optionId) {
			this.selectedOption = null;
		} else {
			this.selectedOption = optionId;
		}
		this.selectedOptionChange.emit(this.selectedOption);
	}

	/**
	 * On item mouse hover
	 */
	public onItemHover(optionId?: number | null): void {
		this.highlightedOptionChange.emit(optionId);
	}

	/**
	 * On changes
	 */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.siteContent && this.siteContent != null) {
			const options: MenuOption[] = [];
			for (const item of this.siteContent) {
				options.push({
					id: item.id,
					name: item.name,
					typeClass: CLASSES_PER_TYPE[item.type]
				});
			}
			this.options = options;
		}
	}
}
